module.exports = __webpack_public_path__ + "img/app-web.ad2682ec.svg";